import { remove, removeBulkMile } from '../index';

export const deleteMileStone = (data) => {
  return remove(`/milestones`, data);
};

export const deleteBulkMileStone = (data) => {
  return removeBulkMile(`/milestones/bulk`, data);
};
